export default __webpack_public_path__ + "static/media/Chhattisgarhi_cf_1.20e268ec.mp3";